import { render, staticRenderFns } from "./AppFile.vue?vue&type=template&id=5c49d1d7&"
import script from "./AppFile.vue?vue&type=script&lang=js&"
export * from "./AppFile.vue?vue&type=script&lang=js&"
import style0 from "./AppFile.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports